import { put } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { ContentActionsService } from '../../commonInfra/contentActions/ContentActions';
import { EditPublishedConnectionReduxAction } from '../actions/EditPublishedConnectionReduxAction';

export function* handleEditPublishedConnection(action: EditPublishedConnectionReduxAction) {
  try {
    ContentActionsService.editPublishedConnection(action.publishedConnection.luid);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
